import { useCallback } from 'react';

import { client } from '../../../api/rest/client';
import { Actions } from '../../../constants/actionTypes';
import { toastErrorTranslated } from '../../../helpers/toast';
import type { TUserDataMappingCongig } from '../../../interfaces/redux/TSettingsState';
import { useMainDispatch } from '../../useMainDispatch';

export const useUserDataMappingActions = () => {
  const dispatch = useMainDispatch();

  const getAndSetUserDataMapping = useCallback(async () => {
    try {
      dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
      const { data: userDataMapping } =
        await client.bot.getUserDataMappingConfig();
      dispatch({
        type: Actions.SET_USER_DATA_MAPPING,
        payload: userDataMapping,
      });
    } catch (error) {
      console.error(error);
      toastErrorTranslated(error);
    } finally {
      dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
    }
  }, [dispatch]);

  const updateUserDataMapping = useCallback(
    async (config: TUserDataMappingCongig) => {
      try {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
        await client.bot.updateUserDataMappingConfig({ body: config });
        dispatch({ type: Actions.SET_USER_DATA_MAPPING, payload: config });
      } catch (error) {
        console.error(error);
        toastErrorTranslated(error);
      } finally {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
      }
    },
    [dispatch],
  );

  return {
    getAndSetUserDataMapping,
    updateUserDataMapping,
  };
};
